import { css } from "@emotion/react";

export const DefaultLayoutStyle = {
  self: css`
    background-color: #f5f9fd;
  `,
};
